// nominationsReducer.ts
import { ActionType } from '../actionTypes';
import { NominationAction } from '../actions';

interface NominationsState {
    loading: boolean;
    error: string | null;
    data: Array<{
      id: number;
      nominee_id: number;
      nominee: {
        id: number;
        name: string;
        pic: string;
        short_desc: string;
        running_call: string;
        nominations: null | any; // Adjust the type based on your actual data structure
        time_in: string;
        CreatedAt: string;
        UpdatedAt: string;
      };
      category_id: number;
      category: {
        id: number;
        category: string;
        time_in: string;
        nominations: null | any; // Adjust the type based on your actual data structure
        CreatedAt: string;
        UpdatedAt: string;
      };
      vote_code: string;
      votes:number;
      time_in: string;
      CreatedAt: string;
      UpdatedAt: string;
    }>;
  }

const initialState: NominationsState = {
  loading: false,
  error: null,
  data: [],
};

const nominationsReducer = (
  state: NominationsState = initialState,
  action: NominationAction
): NominationsState => {
  switch (action.type) {
    case ActionType.LOAD_NOMINATIONS:
            return {loading:true, error:null, data:[]};
        
        case ActionType.LOAD_NOMINATIONS_SUCCESS:
            return {loading:false, error:null, data:action.payload};
        case ActionType.LOAD_NOMINATIONS_ERROR:
            return {loading:false, error:action.payload, data:[]};
        default:
            return state;
  }
};

export default nominationsReducer;